import React, { Component } from 'react';
import styled from 'styled-components';
import { CollapsibleHedge } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';

const StyledHeaderText = styled.div`
  font-family: Nimbus Sans Bold;
  font-size: 16px;
  line-height: 26px;
  color: ${tokens.ColorGrey900};
`;

const StyledText = styled.div`
  padding-bottom: 24px;
`;

const StyledModalContentContainer = styled.div`
  margin: 24px 0px 56px 0px;
  font-size: 16px;
  line-height: 26px;
  color: ${tokens.ColorGrey800};
`;

class ChartEducationModal extends Component<any, any> {
  render(): JSX.Element {
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={'Why does my Retirement Income Goal change over time?'} showClose={true} />
        <ReactModalContent>
          <StyledModalContentContainer>
            <StyledHeaderText>If your goal gradually increases</StyledHeaderText>
            <StyledText>
              Your Retirement Income Goal may increase slightly over time to account for inflation. As the cost of
              living rises due to inflation, you’ll need more income to maintain your lifestyle.
            </StyledText>
            <StyledHeaderText>
              If your goal decreases over time then increases at the end of retirement
            </StyledHeaderText>
            <StyledText>
              Research on retirement spending shows that retirees spend more at the beginning of retirement as they
              enjoy traveling, eating out, and other types of discretionary expenses. As they age, retirees tend to slow
              down and spend less even with price increases due to inflation. However, health costs tend to rise toward
              the end of retirement, which offset reductions in other spending categories. To account for these changes
              in spending, your Retirement Income Goal line may take the shape of a smile.
            </StyledText>
            <StyledHeaderText>If your goal is lower while your spouse is still working</StyledHeaderText>
            <StyledText>
              If you have added spouse information and retire while your spouse keeps working, the Retirement Income
              Goal will only apply to you until your spouse retires. Your household Retirement Income Goal is based on
              replacing a percentage of your pre-retirement income. This amount is divided proportionately, based on
              each person’s pre-retirement salary. When you retire, we assume you will need your entire portion of the
              household Retirement Income Goal. When you add this amount to your working spouse’s net income, it will
              most likely push your combined income past your household Retirement Income Goal.
            </StyledText>
            <CollapsibleHedge
              title={'Show an example'}
              bodyCopy={
                'If you earn $40,000/yr. and your spouse earns $60,000/yr. and we assume you’ll both need 79% of your income in retirement, your Retirement Income Goal is $30,514/yr. and your spouse’s is $48,986/yr. for a combined Retirement Income Goal of $79,500/yr. If you retire before your spouse, we assume you’ll need your entire Retirement Income Goal of $30,514/yr. while your spouse continues to earn a net income of $51,048/yr. Therefore, your combined income will be $81,562/yr. until your spouse retires.'
              }
            />
          </StyledModalContentContainer>
        </ReactModalContent>
      </React.Fragment>
    );
  }
}

export default ChartEducationModal;
